module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame_4269@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame_4269%402x.png
// module id = p4d0
// module chunks = 93